import { mapBasePageProperties } from './basePagePropertiesMapper';
import logger from '3-foundation/Logging/logger';

interface Props extends Umbraco.BasePage {
	heading: string;
}

export const mapSearchPageProperties = async (
	{ heading, ...properties }: Props,
	pageId: string,
	siteId: string,
	locale: string,
): Promise<Content.SearchPageProperties> => {
	try {
		return {
			...(await mapBasePageProperties(properties, siteId, locale)),
			heading,
		};
	} catch (e) {
		logger.error('Could not map SearchPage Properties', e);
		throw new Error('Could not map SearchPage Properties', e);
	}
};
